import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ShopSection, ShopSettings } from '@infrab4a/connect';
import { MessageService } from 'primeng/api';
import { ShopSettingsService } from 'src/app/connect-api/api/shop-settings/shop-settings.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-infobar-form',
  templateUrl: './infobar-form.component.html',
  styleUrl: './infobar-form.component.scss'
})
export class InfobarFormComponent implements OnInit {
  @Input() id: string | null = null;
  form: FormGroup;
  settings: Partial<ShopSettings> & { sections?: ShopSection[] };
  private messageService = inject(MessageService);
  private shopSettingsService = inject(ShopSettingsService);

  constructor(
    private fb: FormBuilder,
    readonly router: Router,
    readonly activatedRoute: ActivatedRoute
  ) {
    this.form = this.fb.group({
      id: [''],
      type: ['INFOBARS'],
      fixed: [false],
      editable: [true],
      infobars: this.fb.array([])
    });
  }

  async ngOnInit(): Promise<void> {
    this.settings = await this.shopSettingsService.getById('GLAM_NEW_HOME');
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    if (this.id) {
      // Edit mode: Load existing section data
      const section = this.settings.sections?.find((s) => s.id === this.id);
      // Populate form with existing data
      if (section) {
        this.form.patchValue({ id: this.id, ...section });
        if (section.infobars) {
          section.infobars.forEach((infobar) => {
            this.infobars.push(this.fb.group({ ...infobar }));
          });
        }
      }
    }

    console.log('this.settings', this.settings);
  }

  get infobars(): FormArray {
    return this.form.get('infobars') as FormArray;
  }

  addInfobar(): void {
    const infobar = this.fb.group({
      id: [crypto.randomUUID()],
      link: [''],
      text: ['', Validators.required],
      active: [true]
    });
    this.infobars.push(infobar);
  }

  removeInfobar(index: number): void {
    this.infobars.removeAt(index);
  }

  onDrop(event: CdkDragDrop<any[]>): void {
    moveItemInArray(
      this.infobars.controls,
      event.previousIndex,
      event.currentIndex
    );
    this.infobars.updateValueAndValidity();
  }

  async onSubmit(): Promise<void> {
    if (this.form.valid) {
      LoaderService.showLoader();
      const newSection = this.getInfobarData();
      const sections = this.settings.sections || [];
      const existingIndex = sections.findIndex((s) => s.id === this.id);

      if (existingIndex >= 0) {
        sections[existingIndex] = newSection;
      } else {
        sections.push(newSection);
      }

      await this.shopSettingsService.update({
        id: this.settings.id,
        sections: sections
      });
    }
    LoaderService.showLoader(false);
    this.messageService.add({
      severity: 'success',
      summary: 'Sucesso',
      detail: 'Infobar salva com sucesso'
    });

    this.router.navigate(['/configuracoes/glam/new-home']);
  }

  private getInfobarData() {
    const formValue = this.form.value;
    return {
      id: formValue.id || crypto.randomUUID(),
      type: formValue.type,
      fixed: formValue.fixed,
      editable: formValue.editable,
      infobars: formValue.infobars
    };
  }
}
